import React, { ReactNode } from 'react';
import { Tag } from 'antd';
import { ClockCircleFilled, MinusCircleFilled, CheckCircleFilled } from '@ant-design/icons';

type Iprops = {
  type: string;
  text: string;
  icon?: ReactNode;
  hideIcon?: Boolean;
}

const SPTag: React.FC<Iprops> = (props) => {
  const { type, text, icon, hideIcon } = props || {};
  const commonStyle:React.CSSProperties = { lineHeight: '30px', fontSize: 14, borderRadius: 6, whiteSpace: 'pre-line' };
  const tagsMap: any = {
    processing: <Tag color="processing" style={{ ...commonStyle, background: '#E6F4FF', color: '#1473FF', border: 'none' }} icon={hideIcon ? '' : (icon || <ClockCircleFilled style={{ color: '#1473FF' }} />)}>{text}</Tag>,
    error: <Tag color="error" style={{ ...commonStyle, background: '#FEEBE8', color: '#F93822', border: 'none' }} icon={hideIcon ? '' : (icon || <MinusCircleFilled style={{ color: '#FF564D' }} />)}>{text}</Tag>,
    success: <Tag color="success" style={{ ...commonStyle, background: '#EAF8F0', color: '#02BC98', border: 'none' }} icon={hideIcon ? '' : (icon || <CheckCircleFilled style={{ color: '#02BC98' }} />)}>{text}</Tag>
  }
  return tagsMap[type];
}

export default SPTag;